import { Box } from '@mui/material'
import { t } from 'i18next'
import React from 'react'
import DatePickerInput from 'src/Common/ui/DatePickerInput'
import Input from 'src/Common/ui/input'
import { indTimeConvert } from 'src/lib/utils'

function FormsDrawer ({ drawType, editState, name, errors, register, formObject, setFormObject, control }) {
    const handleDateChange = (value) => {
        const date = new Date(value)
        date.setDate(date.getDate() + 1)
        date.setUTCHours(0, 0, 0, 0)
        setFormObject(prevState => ({
            ...prevState,
            byWhen: date.toISOString()
        }))
    }
    const handleInput = (e) => {
        setFormObject(prevState => ({
            ...prevState,
            fineAmount: e.target.value
        }))
    }
    const minDate = new Date()
    minDate.setHours(0, 0, 0, 0)
    minDate.setDate(minDate.getDate() - 1)
    return (
        <div className='flex flex-col gap-3 mt-4'>
            <div className='flex flex-col gap-3'>
                <div className='text-primary text-subHeading-2 font-semibold'>Form Name</div>
                <div className='text-muted text-b5'>{name}</div>
            </div>
            <Box display='grid' gridTemplateColumns={'repeat(2, 1fr)'} gap={4}>

                <Box gridColumn='span 1'>
                    <DatePickerInput
                        control={control}
                        required
                        rules={drawType === 'form' && editState.right ? { required: t('From date is required') } : {}}
                        name='byWhen'
                        label={t('By when')}
                        type="number"
                        errors={errors}
                        register={register}
                        value={formObject?.byWhen }
                        onValueChange={handleDateChange}
                        minDate={indTimeConvert(minDate)}
                    />
                </Box>
                <Box gridColumn='span 1'>
                    <Box gridColumn="span 2">
                        <Input
                            control={control}
                            name='formfineamount'
                            label={'Penalties'}
                            placeholder="Enter Fine Amount"
                            type="text"
                            errors={errors}
                            onValueChange={handleInput}
                            value={formObject?.fineAmount}
                        />
                    </Box>
                </Box>
            </Box>

        </div>
    )
}

export default FormsDrawer
